export default __webpack_public_path__ + "static/media/settings.3104fb49.png";